import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cancel: 'Choose later',
    cancelDatePicker: 'Cancel',
    cardPendingCreation:
      'This card is pending creation, you cannot change the deactivation date at this point',
    confirm: 'Confirm',
    confirmDatePicker: 'Confirm',
    removeDeactivationCta: 'Remove deactivation date',
    removeSuccess: 'The deactivation date of this card has been removed.',
    updateSuccess: 'The deactivation date of this card has been changed.',
  },
  fr: {
    cancel: 'Choisir plus tard',
    cancelDatePicker: 'Annuler',
    cardPendingCreation:
      'Cette carte est en attente de création, vous ne pouvez pas modifier la date de désactivation à ce stade',
    confirm: 'Valider',
    confirmDatePicker: 'Confirmer',
    removeDeactivationCta: 'Supprimer la date de désactivation',
    removeSuccess: 'La date de désactivation de cette carte a été supprimée',
    updateSuccess: 'La date de désactivation de cette carte a été modifiée',
  },
} as const);

export default locales;
